import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";

var mutation = gql`
  mutation unAssignResourceFromFormVersion($organizationId: UUID!,  $submissionId:  UUID!) {
    unAssignResourceFromFormVersion(organizationId: $organizationId,  submissionId: $submissionId) 
     
    
  }
`;




export function apiUnAssignResourceFromFormVersion(organizationId, submissionId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .mutate({
                mutation: mutation,
                variables: {organizationId, submissionId},
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.unAssignResourceFromFormVersion);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to unassign template");
                reject(err); // R
            })
    });
}


